import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const Redirect = ({ authenticated = false, history, match }) => {
  useEffect(() => {
    if (authenticated) {
      history.push('/dashboard');
    }
    if (match.params.token) {
      localStorage.setItem('token', match.params.token);
      window.location.reload();
    }
  }, []);

  return <div />;
};

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
});

Redirect.propTypes = {
  authenticated: PropTypes.bool,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, {})(Redirect);
